export const serviceDetails = {
  'mobile-notary': {
    id: 'mobile-notary',
    name: 'Mobile Notary Services',
    description: 'Professional mobile notary service delivered with military-grade precision, identity verification procedures, and secure documentation handling.',
    fullDescription: 'Professional mobile notary service delivered with military-grade precision, identity verification procedures, and secure documentation handling. Our certified notaries come to your location equipped with proper credentials, secure documentation procedures, and the expertise to handle all notarization needs with absolute professionalism.',
    includes: [
      'Notarization of legal documents',
      'ID verification',
      'Witness coordination (if required)',
      'On-site travel to customer location',
      'Secure record logging',
      'Optional scan-back service'
    ],
    basePrice: 55,
    pricing: [
      { label: 'Base Service Fee', price: '$55' },
      { label: 'Travel (0-10 miles)', price: 'Included' },
      { label: 'Additional mileage', price: '$1.50/mile' }
    ],
    addOns: [
      { id: 'scan-back', label: 'Scan-back service', price: 15 },
      { id: 'additional-docs', label: 'Additional documents', price: 10 },
      { id: 'rush', label: 'Rush delivery (under 90 min)', price: 35 },
      { id: 'after-hours', label: 'After-hours service (8PM-8AM)', price: 45 },
      { id: 'weekend', label: 'Weekend service', price: 25 }
    ],
    customerFields: [
      { id: 'document-type', label: 'Document Type', type: 'select', required: true, options: ['Affidavit', 'Power of Attorney', 'Contract', 'Deed', 'Other Legal Document'] },
      { id: 'num-documents', label: 'Number of Documents', type: 'number', required: true, placeholder: 'Enter quantity' },
      { id: 'appointment-address', label: 'Address for Appointment', type: 'text', required: true, placeholder: 'Enter full address' },
      { id: 'preferred-window', label: 'Preferred Appointment Window', type: 'select', required: true, options: ['Morning (8AM-12PM)', 'Afternoon (12PM-5PM)', 'Evening (5PM-8PM)', 'After Hours (8PM-8AM)'] },
      { id: 'witnesses-needed', label: 'Witnesses Needed', type: 'checkbox', required: false },
      { id: 'document-upload', label: 'Upload for Pre-Review (Optional)', type: 'file', required: false },
      { id: 'contact-phone', label: 'Contact Phone Number', type: 'text', required: true, placeholder: '(555) 123-4567' }
    ],
    icon: 'DocumentTextIcon'
  },
  'courier-delivery': {
    id: 'courier-delivery',
    name: 'Courier Delivery',
    description: 'Secure courier delivery service specializing in sensitive documents, legal packets, checks, and confidential materials. Real-time tracking and safe chain of custody included.',
    fullDescription: 'Secure courier delivery service specializing in sensitive documents, legal packets, checks, and confidential materials. Every delivery includes real-time GPS tracking, signature verification, timestamped proof of delivery, and complete chain-of-custody documentation to ensure your materials arrive safely and securely.',
    includes: [
      'Direct pickup & delivery',
      'Chain-of-custody documentation',
      'Signature verification',
      'GPS timestamp logging',
      'Immediate delivery confirmation'
    ],
    basePrice: 45,
    pricing: [
      { label: 'Base Service Fee', price: '$45' },
      { label: 'Distance charge', price: 'Calculated' },
      { label: 'First 10 miles', price: 'Included' }
    ],
    addOns: [
      { id: 'rush', label: 'Rush delivery (under 90 min)', price: 35 },
      { id: 'after-hours', label: 'After-hours service', price: 45 },
      { id: 'weekend', label: 'Weekend service', price: 25 }
    ],
    customerFields: [
      { id: 'pickup-address', label: 'Pickup Address', type: 'text', required: true, placeholder: 'Enter pickup location' },
      { id: 'dropoff-address', label: 'Dropoff Address', type: 'text', required: true, placeholder: 'Enter delivery location' },
      { id: 'item-description', label: 'Item Description', type: 'text', required: true, placeholder: 'Describe the item' },
      { id: 'weight', label: 'Weight (optional)', type: 'number', required: false, placeholder: 'In pounds' },
      { id: 'fragile', label: 'Fragile Item', type: 'checkbox', required: false },
      { id: 'delivery-window', label: 'Required Delivery Window', type: 'select', required: true, options: ['ASAP', '2 Hours', '4 Hours', 'Same Day', 'Next Day'] },
      { id: 'signature-required', label: 'Signature Required', type: 'select', required: true, options: ['Yes', 'No'] },
      { id: 'recipient-name', label: 'Recipient Name', type: 'text', required: true, placeholder: 'Full name' },
      { id: 'recipient-phone', label: 'Recipient Phone', type: 'text', required: true, placeholder: '(555) 123-4567' }
    ],
    icon: 'TruckIcon'
  },
  'legal-docs': {
    id: 'legal-docs',
    name: 'Legal Document Handling',
    description: 'Certified handling, retrieval, and transportation of legal packets such as subpoenas, affidavits, court filings, contracts, and official notices.',
    fullDescription: 'Certified handling, retrieval, and transportation of legal packets such as subpoenas, affidavits, court filings, contracts, and official notices. Our team specializes in court filing delivery, return-of-service documentation, and maintaining secure chain of custody for all legal materials with timestamped proof of delivery and completion confirmation.',
    includes: [
      'Court filing delivery',
      'Return-of-service documentation',
      'Secure transport in sealed envelopes',
      'Timestamped proof of delivery',
      'Completion confirmation'
    ],
    basePrice: 75,
    pricing: [
      { label: 'Base Service Fee', price: '$75' },
      { label: 'Travel (0-10 miles)', price: 'Included' },
      { label: 'Additional mileage', price: '$1.50/mile' }
    ],
    addOns: [
      { id: 'rush', label: 'Rush service', price: 35 },
      { id: 'after-hours', label: 'After-hours service', price: 45 },
      { id: 'weekend', label: 'Weekend service', price: 25 }
    ],
    customerFields: [
      { id: 'document-type', label: 'Type of Legal Document', type: 'select', required: true, options: ['Subpoena', 'Affidavit', 'Court Filing', 'Contract', 'Official Notice', 'Other'] },
      { id: 'court-address', label: 'Court / Law Office Address', type: 'text', required: true, placeholder: 'Enter destination address' },
      { id: 'filing-deadline', label: 'Filing Deadline', type: 'text', required: true, placeholder: 'MM/DD/YYYY HH:MM' },
      { id: 'pickup-address', label: 'Pickup Address', type: 'text', required: true, placeholder: 'Document pickup location' },
      { id: 'dropoff-address', label: 'Dropoff Address', type: 'text', required: true, placeholder: 'Document dropoff location' },
      { id: 'required-docs', label: 'Required Documentation for Service', type: 'textarea', required: true, placeholder: 'List any specific instructions or requirements' }
    ],
    icon: 'ScaleIcon'
  },
  'medical-specimen': {
    id: 'medical-specimen',
    name: 'Medical Specimen Transport',
    description: 'HIPAA-aware transport for temperature-controlled medical specimens or secure healthcare packets.',
    fullDescription: 'HIPAA-aware transport for temperature-controlled medical specimens or secure healthcare packets. Our specialized service includes temperature-controlled storage, complete chain-of-custody protocol, sealed transport containers, and delivery timestamp with lab signature confirmation to ensure sample integrity and regulatory compliance.',
    includes: [
      'Temperature-controlled storage',
      'Chain-of-custody protocol',
      'Sealed transport containers',
      'Delivery timestamp + lab signature'
    ],
    basePrice: 125,
    pricing: [
      { label: 'Base Service Fee', price: '$125' },
      { label: 'First 10 miles', price: 'Included' },
      { label: 'Additional mileage', price: '$1.50/mile' }
    ],
    addOns: [
      { id: 'rush', label: 'Rush transport', price: 35 },
      { id: 'after-hours', label: 'After-hours service', price: 45 },
      { id: 'weekend', label: 'Weekend service', price: 25 }
    ],
    customerFields: [
      { id: 'specimen-type', label: 'Specimen Type', type: 'select', required: true, options: ['Blood Sample', 'Tissue Sample', 'Urine Sample', 'Swab Test', 'Other Biological Material'] },
      { id: 'temperature', label: 'Required Temperature', type: 'select', required: true, options: ['Cold Room (2-8°C)', 'Frozen (-20°C)', 'Ambient (Room Temp)'] },
      { id: 'lab-address', label: 'Lab Address', type: 'text', required: true, placeholder: 'Destination lab address' },
      { id: 'pickup-location', label: 'Pickup Location', type: 'text', required: true, placeholder: 'Specimen pickup address' },
      { id: 'release-contact', label: 'Release Authorization Contact', type: 'text', required: true, placeholder: 'Contact name and phone' },
      { id: 'special-instructions', label: 'Special Instructions', type: 'textarea', required: false, placeholder: 'Any special handling requirements' }
    ],
    icon: 'BeakerIcon'
  },
  'business-delivery': {
    id: 'business-delivery',
    name: 'Business Delivery',
    description: 'Reliable scheduled or on-demand delivery for corporate documents, payroll, internal materials, and inter-office transfers.',
    fullDescription: 'Reliable scheduled or on-demand delivery for corporate documents, payroll, internal materials, and inter-office transfers. Our business delivery service includes scheduled recurring pickups, proof-of-delivery logs, corporate chain-of-custody documentation, and secure envelope transport tailored to your company\'s specific needs.',
    includes: [
      'Scheduled recurring pickups',
      'Proof-of-delivery logs',
      'Corporate chain-of-custody',
      'Secure envelope transport'
    ],
    basePrice: 65,
    pricing: [
      { label: 'Base Service Fee', price: '$65' },
      { label: 'First 10 miles', price: 'Included' },
      { label: 'Additional mileage', price: '$1.50/mile' },
      { label: 'Recurring routes', price: 'Custom quoted' }
    ],
    addOns: [
      { id: 'rush', label: 'Rush delivery', price: 35 },
      { id: 'after-hours', label: 'After-hours service', price: 45 },
      { id: 'weekend', label: 'Weekend service', price: 25 }
    ],
    customerFields: [
      { id: 'business-name', label: 'Business Name', type: 'text', required: true, placeholder: 'Company name' },
      { id: 'pickup-address', label: 'Pickup Address', type: 'text', required: true, placeholder: 'Business pickup location' },
      { id: 'dropoff-address', label: 'Dropoff Address', type: 'text', required: true, placeholder: 'Business delivery location' },
      { id: 'material-type', label: 'Material Type', type: 'select', required: true, options: ['Corporate Documents', 'Payroll', 'Internal Materials', 'Inter-Office Transfer', 'Other'] },
      { id: 'recurrence', label: 'Delivery Schedule', type: 'select', required: true, options: ['One-Time', 'Daily', 'Weekly', 'Bi-Weekly', 'Monthly'] },
      { id: 'special-notes', label: 'Special Notes', type: 'textarea', required: false, placeholder: 'Any additional instructions' }
    ],
    icon: 'BriefcaseIcon'
  }
};